import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'

const Button = styled.button`
    background-color: transparent;
    border-color: ${props => props.inverse
        ? props.theme.font_light
        : props.theme.font_dark
    };
    border-radius: 4px;
    border-width: 3px;
    border-style: ${props => props.unstyled
        ? 'none'
        : 'solid'
    };
    cursor: pointer;
    display: inline-block;
    font-size: 0.9em;
    color: ${props => props.inverse
        ? props.theme.font_light
        : props.theme.font_dark
    };
    font-weight: ${props => props.theme.font_weight_bold};
    font-family: ${props => props.font == 'body'
        ? props.theme.font_body
        : props.theme.font_header
    };
    height: 2.75em;
    letter-spacing: 0.125em;
    line-height: 2.75em;
    padding: 0 2em;
    text-align: center;
    text-decoration: none;
    text-indent: 0.125em;
    text-transform: uppercase;
    white-space: nowrap;
    &:hover {
        color: ${props => props.hover
        ? props.hover
        : props.theme.accent
    };
        border-color: ${props => props.hover
        ? props.hover
        : props.theme.accent
    };
    }
`
const ButtonGone = Button.extend`
@media all and (max-width: 750px) {
    display: none;
}
`
export { Button, ButtonGone }


// WEBPACK FOOTER //
// ./src/components/button.js